import { AxiosInstance } from 'axios/index';
import { EntityByIdParam, ModuleParam } from '@src/api/types.ts';

export class CommonApi {
  constructor(private instance: AxiosInstance) {}

  public async getModules() {
    return this.instance.get<AppModule[]>('common/module/').then((res) => res.data);
  }

  public async getPartitions(params: ModuleParam) {
    return this.instance.get<Partition[]>('common/partition/', { params }).then((res) => res.data);
  }
  public async getPartition({ id }: EntityByIdParam) {
    return this.instance.get<Partition>(`common/partition/${id}`).then((res) => res.data);
  }

  public async getTags(params: GetTagsParams) {
    return this.instance.get<Tag[]>('common/tag/', { params }).then((res) => res.data);
  }
}

export type GetTagsParams = { partition?: number };

export interface Tag {
  id: number;
  title: string;
  module: number;
  partition: number;
}

export enum MODULE_TYPE {
  schedule = 'schedule',
  programs = 'programs',
  profile = 'profile',
  articles = 'articles',
  questions = 'questions',
  clients = 'clients',
  consultations = 'consultations',
  events = 'events',
  coaches = 'coaches',
  shop = 'shop',
  statistics = 'statistics',
}

export enum PERMISSIONS_ENUM {
  add_module = 'add_module',
  can_sell = 'can_sell',
  can_buy = 'can_buy',
  change_module = 'change_module',
  delete_module = 'delete_module',
  view_module = 'view_module',
}

export type AppModule = {
  id: number;
  code: string;
  verbose_name: string;
  module_type: MODULE_TYPE;
  permissions: PERMISSIONS_ENUM[];
  order: number;
};

export type Partition = {
  id: number;
  name: string;
  order: number;
};
